module.exports = __webpack_public_path__ + "img/background-logo.cc8152e1.png";